export default __webpack_public_path__ + "images/d4302a618e9c4f13a8e96b7988b62462.svg";